import { Injectable } from "@angular/core";
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { AppService } from './app.service';


@Injectable()
export class AuthExternalB2BGuard implements CanActivate {
    constructor(public appService: AppService, private router: Router) {

    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
        return this.appService.getUserProfile().then(user => {
            if (user.isBusinessAccount() && !user.isRoleGlobal()) {
                return true;
            }
            this.router.navigate(['/organization']);
            return false;
        });
    }

}



// WEBPACK FOOTER //
// ./client/views/services/auth-external-b2b.guard.ts